/* eslint-disable */
import api from '../_api';
import { store } from '@/_store';

function dictToURI(dict) {
  const str = [];
  for (const p in dict) {
    str.push(`${encodeURIComponent(p)}=${encodeURIComponent(dict[p])}`);
  }
  let query = str.join('&');
  if (query.length > 0) query = `?${query}`;
  return query;
}

const generic_service = (pathname) => ({
  getItems(kwargs = {}) {
    return api.get(`/${pathname}/`, {
      params: kwargs,
    });
  },
  getAll(kwargs = {}) {
    return api.get(`/${pathname}/${dictToURI(kwargs)}`);
  },
  getItem(id) {
    return api.get(`/${pathname}/${Number(id)}/`, {params: {scope: store.getters['account/scope']}});
  },
  getItemUrl(url) {
    return api.get(url);
  },
  patchItem(id, payload) {
    return api.patch(`/${pathname}/${id}/`, payload);
  },
  postItem(payload) {
    return api.post(`/${pathname}/`, payload);
  },
  search(query) {
    return api.get(`/${pathname}/?q=${query}`);
  },
  deleteItem(id) {
    return api.delete(`/${pathname}/${id}/`, {params: {scope: store.getters['account/scope']}});
  },
});

const genericService = generic_service;
export {
  genericService,
  generic_service,
  dictToURI,
};
